import axios from 'axios'
import { URLS } from '../factories'
import { AuthModule } from '../store'

export default {
  async getContentById (id: string, depth = 0) {
    const requestURL = AuthModule.isProduction ? URLS.production.dotCMSApiUrl : URLS.replica.dotCMSApiUrl
    const url = requestURL + `/api/content/id/${id}/depth/${depth}`
    return axios.get(url, { timeout: 30000 })
  }
}
